
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as ModelPrincipal } from '../../controlador';
    import { ControladorSeccion } from './controlador';
    import buscador from './lista-buscador.vue';
    import listado from './lista-listado.vue';
    import archivo from './lista-archivo.vue';
    import comprobar from './editar/editar-pedido.vue';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador,
            listado,
            archivo,
            comprobar,

        }
    } )
    export default class Componente extends Vue
    {
        public get Principal() { return Vue.observable( ModelPrincipal ); }
        public Controlador: ControladorSeccion = null;
        public get Estado() { return this.Controlador.Vista.Estado; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        created()
        {
            this.Controlador = new ControladorSeccion();
        }

        mounted()
        {
            this.Controlador.Iniciar();
        }


    }
